import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";

@Component({
  selector: "dev-receipt-screen",
  template: `
    <div
      id="dev-disable-scroll-input"
      dir="rtl"
      class="h-screen w-screen flex flex-row justify-center items-start"
    >
      <div class="p-4">
        <receipt-page-component></receipt-page-component>
      </div>
    </div>
  `,
  styleUrls: ["../../../css/tailwind-utils.scss"],
})
export class DevReceiptScreenComponent {
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
}



// WEBPACK FOOTER //
// ./src/app/development/ui/dev-receipt-screen.component.ts